export const SocketEvents = {
  HOUSE_CONNECTION_UPDATES: 'device_connection_update',
	SYNC_MESSAGE: 'message',
	SYNC_CONN_UPDATE: 'conn_update',
	SYNC_SYNC_STATES: 'resync_states',
	NOVA_CONN_UPDATE: 'nova_conn_update',
  NOVA_CONTROL: 'nova_control',
  NOVA_POWER_UPDATE: 'nova_power_update',
};